import { getDataOrNull } from "@msys/common";
import { CardContainer } from "@msys/ui";
import { ChatOutlined as ChatOutlinedIcon } from "@mui/icons-material";
import { useTranslate } from "@tolgee/react";
import { ClientInputsList } from "../client-inputs/ClientInputsList.js";
import { useRequirementClientInputsQuery } from "./RequirementClientInputsBox.generated.js";

interface Props {
  requirementId: string;
  // The project the requirement is being viewed in; authorizes reads of
  // requirements shared into another project/organisation.
  projectId: string;
}

export const RequirementClientInputsBox = ({
  requirementId,
  projectId,
}: Props) => {
  const { t } = useTranslate(["ProjectOverview", "Global"]);

  const query = useRequirementClientInputsQuery({
    variables: { ownerId: requirementId, projectId },
  });
  const clientInputs =
    getDataOrNull(query.data?.clientInputs)?.clientInputs ?? [];

  if (clientInputs.length === 0) return null;

  return (
    <CardContainer
      Icon={<ChatOutlinedIcon />}
      title={t("Client inputs", { ns: "ProjectOverview" })}
      isExpandable
      isInitiallyClosed={false}
    >
      <ClientInputsList clientInputs={clientInputs} />
    </CardContainer>
  );
};
